import { AxiosInstance } from 'axios';

export type OrderBulkFinanceUpdateRequestCommodity = {
  guid: string;
  payment: string;
};

export type OrderBulkFinanceUpdateRequestItem = {
  orderGuid: string;
  payment: string;
  commodities?: OrderBulkFinanceUpdateRequestCommodity[];
};

export type OrderBulkFinanceUpdateRequest = OrderBulkFinanceUpdateRequestItem[];

export class OrderBulkFinanceService {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  update(request: OrderBulkFinanceUpdateRequest) {
    return this.instance.put('/bulk/orders/finances', request);
  }
}
